__turbopack_context__.v({
  "emptyState": "AddOnsEmptyState-module-scss-module__mQIgTG__emptyState",
  "emptyStateIcon": "AddOnsEmptyState-module-scss-module__mQIgTG__emptyStateIcon",
  "emptyStateLink": "AddOnsEmptyState-module-scss-module__mQIgTG__emptyStateLink",
  "emptyStateMessage": "AddOnsEmptyState-module-scss-module__mQIgTG__emptyStateMessage",
  "emptyStateTitle": "AddOnsEmptyState-module-scss-module__mQIgTG__emptyStateTitle",
});
